import { ValTicker } from "../ValTicker";

export function ValDailyV2() {
  return <ValTicker />;
}
